module.exports = {
        srcSet: __webpack_public_path__ + "app_stores_banner_google_HE-270-bbd8ce6e2653b20d.digested.png"+" 270w",
        images: [{path: __webpack_public_path__ + "app_stores_banner_google_HE-270-bbd8ce6e2653b20d.digested.png",width: 270,height: 80}],
        src: __webpack_public_path__ + "app_stores_banner_google_HE-270-bbd8ce6e2653b20d.digested.png",
        toString: function(){return __webpack_public_path__ + "app_stores_banner_google_HE-270-bbd8ce6e2653b20d.digested.png"},
        
        width: 270,
        height: 80
      }